import { ENVIRONMENT_LINK_ENDPOINTS_NAMES } from '../../../../constants/common/environmentLinkEndpointNames';
import { HEADER_LINKS_TYPES, PA_EXCLUDES } from '../constants/headerLinkTypes';
import { configs } from '../../../../constants/configs/configs';
import { EXTRA_ACTIONS } from '../constants/headerLinkTypes';

const {
    routes
} = configs;

export const getinsuredHeaderLogo = {
    link: false
};

export const getinsured = {
    linkDetails: [
        {
            name: 'login',
            text: 'header.login',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGIN,
            type: HEADER_LINKS_TYPES.LINK,
            visible: (environment) => environment.anonymous
        },
        {
            name: 'home',
            text: 'header.home',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link'],
            symbols: ['home'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus)=> !PA_EXCLUDES.some(excludedPath => excludedPath === currentPath) && !environment.anonymous && !errorStatus
        },
        {
            name: 'secured-mail',
            text: 'header.inbox',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName:['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['lock', 'envelope'],
            path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.UNREAD_MESSAGES,
            type: HEADER_LINKS_TYPES.ICON,
            visible: (environment, currentPath, telexEnabled, errorStatus) => !telexEnabled && !PA_EXCLUDES.some(excludedPath => excludedPath === currentPath) && !environment.anonymous && !errorStatus,
            showUnreadMessage: true
        },
        {
            name: 'secured-mail-telex',
            text: 'header.inbox',
            textClassname: ['usa-sr-only'],
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            linkClassName: ['usa-nav__link gi-main__nav__primary-item__link secured-mail'],
            symbols: ['lock', 'envelope'],
            path: routes.NEW_INBOX_HOME,
            type: HEADER_LINKS_TYPES.ICON_REACT_ROUTER,
            visible: (environment, currentPath, telexEnabled, errorStatus) => telexEnabled && !PA_EXCLUDES.some(excludedPath => excludedPath === currentPath) && !environment.anonymous && !errorStatus,
            showUnreadMessage: true
        },
        {
            name: 'my-authentication',
            text: 'header.myAccount',
            className: ['usa-nav__primary-item gi-main__nav__primary-item'],
            btnClassName: ['dropdown__pos--02'],
            ariaClassName: ['extended-nav-section-two'],
            path: '#',
            type: HEADER_LINKS_TYPES.DROPDOWN,
            statesHasFeature: environment => environment.stateCode === 'PA',
            visible: (environment, currentPath, telexEnabled, errorStatus) => !PA_EXCLUDES.some(excludedPath => excludedPath === currentPath) && !environment.anonymous && !errorStatus,
            dropdown: [
                {
                    name: 'authentication-settings',
                    text: 'header.myAccount.accountSettings',
                    className: ['usa-nav__submenu-item'],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.SETTINGS,
                    type: HEADER_LINKS_TYPES.LINK,
                    visible: environment => environment.user
                },
                {
                    name: 'dashboard',
                    text: 'header.myAccount.dashboard',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[''],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.DASHBOARD,
                    type: HEADER_LINKS_TYPES.LINK
                },
                {
                    name: 'logout',
                    text: 'header.myAccount.logout',
                    className: ['usa-nav__submenu-item'],
                    linkClassName:[],
                    path: ENVIRONMENT_LINK_ENDPOINTS_NAMES.LOGOUT,
                    type: HEADER_LINKS_TYPES.LINK,
                    extraAction: EXTRA_ACTIONS.CHECK_SSAP,
                    beforeClick : ()=> {
                        sessionStorage.removeItem('isInImpersonationMode');
                        sessionStorage.removeItem('impersonateHHID');
                    }
                }
            ]
        }
    ]
};